<!--
 * @Author: baike
 * @LastEditors: baike
-->
<template>
  <div class="header">
    <div class="header-left">
      <div class="logos">
        <img @click="hanldeClick" class="logo" src="../../assets/logo.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    hanldeClick(){
        this.$router.push({
        path: "/",
      });
    }
  },
};
</script>

<style lang='scss' scoped>
.header {
  width: 100%;
  height: 72px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  .header-left {
    width: 1440px;
    margin: auto;
    .logo {
      margin: 18px 0;
      width: 200px;
      height: 36px;
      cursor: pointer;
    }
  }
}
</style>